import {css} from 'styled-components'
import {displayItemInputCommonStyle, InputErrorProps} from '../DisplayItem'
import {Colors} from '../Constants'

export const CustomResidentTextFieldStyle = css<InputErrorProps>`
  ${displayItemInputCommonStyle}
  border:  ${props => props.hasError === true ? `${Colors.Alert} 1px solid` : `${Colors.AccentLight} 1px solid`};

  ${props => props.hasError === true ? `background-color: rgb(253, 245, 246)` : ``};

  &:focus {
    border-color:  ${props => props.hasError === true ? `${Colors.Alert}` : `${Colors.AccentDark}`};
  }

  ::placeholder {
    color: ${Colors.Placeholder}
  }
`